import { Box, Button, IconHeart } from 'braid-design-system';

interface LikeButtonProps {
  likeStatus?: boolean;
  likeLabel: string;
  onClick?: () => void;
}

export default ({ likeLabel, likeStatus, onClick }: LikeButtonProps) => (
  <Box borderRadius="full">
    <Button
      tone={!likeStatus ? 'neutral' : 'brandAccent'}
      variant="transparent"
      icon={!likeStatus ? <IconHeart /> : <IconHeart active />}
      onClick={onClick}
      size="small"
    >
      {likeLabel}
    </Button>
  </Box>
);
